// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reorder_grid__BO0DZ {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 8px;
    touch-action: manipulation;
}

@media (min-width: 768px) {
    .reorder_grid__BO0DZ {
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: 10px;
    }
}

.reorder_thumb__Qu5S5 {
    position: relative;
    aspect-ratio: 1 / 1;
    border-radius: 6px;
    overflow: hidden;
    background: #dee2e6;
    cursor: grab;
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    box-sizing: border-box;
    border: 2px solid transparent;
    transition: border-color 120ms ease, transform 120ms ease;
}

.reorder_thumb__Qu5S5:active {
    cursor: grabbing;
}

.reorder_selected__RCC0N {
    border-color: var(--mantine-color-blue-6);
    transform: scale(0.96);
}

.reorder_thumbImg__sDWay {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    pointer-events: none;
}

.reorder_thumbIndex__8LG3R {
    position: absolute;
    top: 4px;
    left: 4px;
    background: rgba(0,0,0,0.55);
    color: white;
    font-size: 10px;
    line-height: 1;
    padding: 3px 5px;
    border-radius: 3px;
    pointer-events: none;
}

.reorder_thumbBadge__-gjj6 {
    position: absolute;
    top: 4px;
    right: 4px;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    background: var(--mantine-color-yellow-7);
    color: black;
    font-size: 10px;
    line-height: 1;
    padding: 3px 5px;
    border-radius: 3px;
    pointer-events: none;
    font-weight: 600;
}

.reorder_thumbCheck__6uMul {
    position: absolute;
    bottom: 28px;
    right: 4px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--mantine-color-blue-6);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
}

.reorder_thumbTime__wKci8 {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.7), transparent);
    color: white;
    font-size: 10px;
    padding: 12px 4px 4px;
    pointer-events: none;
    text-align: center;
}

.reorder_dragOverlay__TOxwe {
    position: relative;
    width: 160px;
    height: 160px;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(0,0,0,0.35);
    transform: rotate(-2deg);
}

.reorder_dragCount__p7hM\\+ {
    position: absolute;
    top: 4px;
    right: 4px;
}

.reorder_actionBar__xYm33 {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    border-top: 1px solid var(--mantine-color-gray-3);
    padding: 10px 16px;
    z-index: 100;
    box-shadow: 0 -4px 12px rgba(0,0,0,0.05);
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Galeries/Reorder/reorder.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,4DAA4D;IAC5D,QAAQ;IACR,0BAA0B;AAC9B;;AAEA;IACI;QACI,4DAA4D;QAC5D,SAAS;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,2BAA2B;IAC3B,sBAAsB;IACtB,6BAA6B;IAC7B,yDAAyD;AAC7D;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yCAAyC;IACzC,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iEAAiE;IACjE,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;IACvC,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,iDAAiD;IACjD,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,wDAAwD;AAC5D","sourcesContent":[".grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n    gap: 8px;\n    touch-action: manipulation;\n}\n\n@media (min-width: 768px) {\n    .grid {\n        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n        gap: 10px;\n    }\n}\n\n.thumb {\n    position: relative;\n    aspect-ratio: 1 / 1;\n    border-radius: 6px;\n    overflow: hidden;\n    background: #dee2e6;\n    cursor: grab;\n    user-select: none;\n    -webkit-user-select: none;\n    -webkit-touch-callout: none;\n    box-sizing: border-box;\n    border: 2px solid transparent;\n    transition: border-color 120ms ease, transform 120ms ease;\n}\n\n.thumb:active {\n    cursor: grabbing;\n}\n\n.selected {\n    border-color: var(--mantine-color-blue-6);\n    transform: scale(0.96);\n}\n\n.thumbImg {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n    pointer-events: none;\n}\n\n.thumbIndex {\n    position: absolute;\n    top: 4px;\n    left: 4px;\n    background: rgba(0,0,0,0.55);\n    color: white;\n    font-size: 10px;\n    line-height: 1;\n    padding: 3px 5px;\n    border-radius: 3px;\n    pointer-events: none;\n}\n\n.thumbBadge {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n    background: var(--mantine-color-yellow-7);\n    color: black;\n    font-size: 10px;\n    line-height: 1;\n    padding: 3px 5px;\n    border-radius: 3px;\n    pointer-events: none;\n    font-weight: 600;\n}\n\n.thumbCheck {\n    position: absolute;\n    bottom: 28px;\n    right: 4px;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    background: var(--mantine-color-blue-6);\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n}\n\n.thumbTime {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: linear-gradient(to top, rgba(0,0,0,0.7), transparent);\n    color: white;\n    font-size: 10px;\n    padding: 12px 4px 4px;\n    pointer-events: none;\n    text-align: center;\n}\n\n.dragOverlay {\n    position: relative;\n    width: 160px;\n    height: 160px;\n    border-radius: 6px;\n    overflow: hidden;\n    box-shadow: 0 8px 24px rgba(0,0,0,0.35);\n    transform: rotate(-2deg);\n}\n\n.dragCount {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n}\n\n.actionBar {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: white;\n    border-top: 1px solid var(--mantine-color-gray-3);\n    padding: 10px 16px;\n    z-index: 100;\n    box-shadow: 0 -4px 12px rgba(0,0,0,0.05);\n    padding-bottom: calc(10px + env(safe-area-inset-bottom));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `reorder_grid__BO0DZ`,
	"thumb": `reorder_thumb__Qu5S5`,
	"selected": `reorder_selected__RCC0N`,
	"thumbImg": `reorder_thumbImg__sDWay`,
	"thumbIndex": `reorder_thumbIndex__8LG3R`,
	"thumbBadge": `reorder_thumbBadge__-gjj6`,
	"thumbCheck": `reorder_thumbCheck__6uMul`,
	"thumbTime": `reorder_thumbTime__wKci8`,
	"dragOverlay": `reorder_dragOverlay__TOxwe`,
	"dragCount": `reorder_dragCount__p7hM+`,
	"actionBar": `reorder_actionBar__xYm33`
};
export default ___CSS_LOADER_EXPORT___;
